import GeneratedProjectStore from "./generated/GeneratedProjectStore"

class ProjectStore extends GeneratedProjectStore {

}

export const projectStore = new ProjectStore()
